module.exports = __webpack_public_path__ + "img/57.eaab8c36.jpg";